export default __webpack_public_path__ + "static/media/domain.f1641636.svg";